<template>
  <div class="main-search">
    <div class="search-nav" ref="navs">
      <router-link
        to="/searchIndex/mainSearch/resources"
        :class="{ 'for-en': $i18n.locale === 'en' }"
      >
        <span @click="changeBlockLeft(0)">{{
          $t("search.studyResources")
        }}</span>
      </router-link>
      <router-link
        to="/searchIndex/mainSearch/project"
        :class="{ 'for-en': $i18n.locale === 'en' }"
      >
        <span @click="changeBlockLeft(1)">{{ $t("search.program") }}</span>
      </router-link>
      <router-link
        to="/searchIndex/mainSearch/plan"
        :class="{ 'for-en': $i18n.locale === 'en' }"
      >
        <span @click="changeBlockLeft(2)">{{ $t("search.trainPlan") }}</span>
      </router-link>
      <router-link
        to="/searchIndex/mainSearch/knowledges"
        :class="{ 'for-en': $i18n.locale === 'en' }"
      >
        <span @click="changeBlockLeft(3)">{{
          $t("search.contentCenter")
        }}</span>
      </router-link>
      <router-link
        to="/searchIndex/mainSearch/elective"
        :class="{ 'for-en': $i18n.locale === 'en' }"
      >
        <span @click="changeBlockLeft(4)">{{ $t("search.courseCenter") }}</span>
      </router-link>
      <i
        class="move-block"
        :style="'left:' + blockLeft + 'px;width:' + blockWidth + 'px;'"
      ></i>
    </div>
    <div class="main-view">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: "mainSearch",
  data() {
    return {
      blockLeft: 10,
      blockWidth: null,
      navs: null,
    };
  },
  mounted() {
    if (this.$store.state.searchNav !== 0) {
      this.changeBlockLeft(this.$store.state.searchNav);
    }
  },
  methods: {
    changeBlockLeft(type) {
      this.blockLeft = this.$refs.navs.children[type].children[0].offsetLeft;
      this.blockWidth = this.$refs.navs.children[type].children[0].offsetWidth;
      if (event) {
        this.$store.commit("changeNav", type);
      }
      this.$store.commit("changeWord", this.$parent.key);
    },
  },
};
</script>
<style lang="less" scoped>
.main-search {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.search-nav {
  display: flex;
  width: 100%;
  align-items: center;
  height: 5vh;
  min-height: 30px;
  background: #f7f7f7;
  color: #666666;
  font-size: 0.24rem;
  position: relative;
  overflow-x: auto;
  a {
    display: block;
    text-decoration: none;
    color: #666666;
    width: 20%;
    &.for-en {
      padding: 0 0.2rem;
      width: auto;
    }
  }
  span {
    display: block;
    text-align: center;
    width: auto;
    white-space: nowrap;
  }
  .move-block {
    display: block;
    position: absolute;
    width: 20%;
    height: 0.04rem;
    background: #005587;
    left: 0;
    bottom: 0;
    transition: left 0.5s;
  }
}
.main-view {
  height: 89vh;
  overflow: auto;
}
</style>
